// Canonical contaminant-group ordering and display labels, shared by the
// Rule Library admin and the per-system monitoring schedule. Tokens are the
// backend's contaminant_group values (see data/regulatory_rules_seed.json).

export const GROUPS = [
  "INORGANIC",
  "SECONDARY",
  "VOC",
  "SOC",
  "RADIOLOGICAL",
  "DBP",
  "MICROBIAL",
] as const;

export const GROUP_LABEL: Record<string, string> = {
  INORGANIC: "Inorganics",
  SECONDARY: "Secondary standards",
  VOC: "Volatile organics",
  SOC: "Synthetic organics",
  RADIOLOGICAL: "Radiologicals",
  DBP: "Disinfection byproducts",
  MICROBIAL: "Microbial",
};

/** Display label, falling back to the raw token for groups added later. */
export function groupLabel(group: string): string {
  return GROUP_LABEL[group] ?? group;
}

/** Bucket items by group, ordered per GROUPS with unknown groups appended
 * in first-seen order. */
export function bucketByGroup<T>(items: T[], groupOf: (item: T) => string): [string, T[]][] {
  const map = new Map<string, T[]>();
  for (const item of items) {
    const g = groupOf(item);
    const list = map.get(g) ?? [];
    list.push(item);
    map.set(g, list);
  }
  const known = GROUPS.filter((g) => map.has(g)).map((g): [string, T[]] => [g, map.get(g)!]);
  const unknown = [...map.entries()].filter(([g]) => !(GROUPS as readonly string[]).includes(g));
  return [...known, ...unknown];
}
